import instance from './axiosInstance';

export const policyUrl = '/precision_policies';

export const getPolicies = (http = instance, options = {}) => http.get(policyUrl, options);

export const updatePolicy = (payload, http = instance, options = {}) =>
  http.post(policyUrl, payload, options);

export const clonePolicy = (pid, http = instance, options = {}) =>
  http.post(`${policyUrl}/${pid}/clone`, options);

export const reorderPolicies = (payload, http = instance, options = {}) =>
  http.post(`${policyUrl}/reorder`, payload, options);

export const deletePolicy = (pid, http = instance, options = {}) =>
  http.delete(`${policyUrl}/${pid}/delete`, options);

export const activatePolicy = (pid, http = instance, options = {}) =>
  http.post(`${policyUrl}/${pid}/activate`, options);

export const getResiliencyData = (payload, http = instance, options = {}) =>
  http.post(`/resiliency`, payload, options);
